import { api } from "../../api/client";

export interface PollingStation {
  id: string;
  name: string;
  code: string;
  branchId: string;
  wardId: string | null;
  constituencyId: string | null;
  districtId: string | null;
  registeredVoters: number;
  lat?: number | null;
  lng?: number | null;
}

interface List<T> { items: T[]; }

export const PollingStationsApi = {
  listForBranch: (bid: string) =>
    api<List<PollingStation>>(`/branches/${bid}/polling-stations`),
  create: (bid: string, body: { name: string; code: string; branchId: string; registeredVoters?: number; lat?: number; lng?: number }) =>
    api<PollingStation>(`/branches/${bid}/polling-stations`, { method: "POST", body: JSON.stringify(body) }),
  get: (id: string) => api<PollingStation>(`/polling-stations/${id}`),
  update: (id: string, body: Partial<{ name: string; code: string; registeredVoters: number; lat: number; lng: number }>) =>
    api<PollingStation>(`/polling-stations/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: string) => api<void>(`/polling-stations/${id}`, { method: "DELETE" }),
};
